var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "dv-border-box-13",
    {
      staticClass: "bayes-classifier",
      staticStyle: {
        display: "flex",
        "box-sizing": "border-box",
        padding: "2em"
      }
    },
    [
      _c(
        "dv-border-box-12",
        { staticStyle: { padding: "1em 0em" }, attrs: { dur: 5 } },
        [
          _c(
            "div",
            { staticClass: "dataV-box" },
            [
              _c("help", { attrs: { help_msg: _vm.help_info.header_help } }),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.sample_name,
                      expression: "sample_name"
                    }
                  ],
                  staticStyle: {
                    "font-size": "15px",
                    margin: "1em",
                    width: "100px"
                  },
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.sample_name = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    }
                  }
                },
                _vm._l(_vm.cls_list, function(v, key, idx) {
                  return _c("option", { key: idx, domProps: { value: key } }, [
                    _vm._v(_vm._s(v.name))
                  ])
                }),
                0
              ),
              _vm._v(" "),
              _c("table-img", {
                staticStyle: { "margin-left": "1em" },
                attrs: { data: _vm.data },
                on: { click_pic: _vm.pic_deal }
              }),
              _vm._v(" "),
              _c("div", {
                staticStyle: { flex: "1", height: "30px", "min-width": "50px" }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("dv-border-box-12", [
        _c(
          "div",
          { staticClass: "dataV-box" },
          [
            _c("help", {
              attrs: {
                help_msg: _vm.help_info.editor_help,
                style_str: "top:10px;"
              }
            }),
            _vm._v(" "),
            _c("edit-table-canvas", {
              attrs: {
                editable: 0,
                data: _vm.current_data.data,
                data_title: "样本数据"
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "left_side_bar" }, [
              _c("button", { on: { click: _vm.clone_left } }, [
                _vm._v("克隆左侧")
              ]),
              _vm._v(" "),
              _c("button", { on: { click: _vm.add_train } }, [
                _vm._v("添加到样本")
              ]),
              _vm._v(" "),
              _c("button", { on: { click: _vm.add_new_to_bayes_table } }, [
                _vm._v("添加识别")
              ]),
              _vm._v(" "),
              _c("button", { on: { click: _vm.classify_data } }, [
                _vm._v("分类识别")
              ]),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.classify_mode,
                      expression: "classify_mode"
                    }
                  ],
                  staticStyle: { "min-width": "45px" },
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.classify_mode = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    }
                  }
                },
                [
                  _c("option", { attrs: { value: "naive_bayes" } }, [
                    _vm._v("朴素贝叶斯")
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "naive_bayes_lps" } }, [
                    _vm._v("朴素贝叶斯-拉普拉斯优化")
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c("edit-table-canvas", {
              attrs: {
                editable: 3,
                data: _vm.new_data,
                data_title: "待分类数据"
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "dv-border-box-12",
        {
          staticStyle: {
            display: "flex",
            "box-sizing": "border-box",
            padding: "2em"
          }
        },
        [
          _c(
            "div",
            { staticClass: "dataV-box" },
            [
              _c("help", {
                attrs: {
                  help_msg: _vm.help_info.table_help,
                  style_str: "top:-6px;right:-15px"
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "left_side_bar" }, [
                _c(
                  "button",
                  {
                    on: {
                      click: function($event) {
                        return _vm.table_switch(1)
                      }
                    }
                  },
                  [_vm._v("特征表")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    on: {
                      click: function($event) {
                        return _vm.table_switch(2)
                      }
                    }
                  },
                  [_vm._v("概率表")]
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: { "max-width": "100%", "over-flow": "auto" },
                  attrs: { id: "result_table" }
                },
                [
                  _c("array-table", {
                    attrs: {
                      data: _vm.table_show_data,
                      head: _vm.feature_data_head,
                      cell_width: _vm.cell_width,
                      config: { title_mode: "value" }
                    },
                    on: { cellEnter: _vm.cell_enter }
                  })
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }